<template>
    <div class="address-page">
        <div class="header-wrap">
            <div class="header-wrap-inner">
                <div class="main-title">收货地址</div>
                <el-button type="primary" size="small" @click="addVisible = true">添加新地址</el-button>
            </div>
        </div>
        
        <div class="main-wrap">
            <div class="no-content" v-if="list.length == 0">
                <i class="ic-empty"></i> 
                <span class="text">暂无地址</span>
            </div>
            <div class="address-list" v-else>
                <div class="item" v-for="item in list" :key="item.address_id">
                    <div class="name-wrap">
                        <span class="name">{{item.address_contact_name}}</span>
                        <span class="phone">{{item.address_contact_phone}}</span>
                        <el-tag type="info" size="small" v-if="item.address_is_default=='y'">默认地址</el-tag>
                    </div>
                    <div class="detail">
                        {{item.region_province_string || ''}}
                        {{item.region_city_string || ''}}
                        {{item.region_district_string || ''}}
                        {{item.address_string || ''}}
                    </div>
                    <div class="btns">
                        <el-button type="text" @click="editAddress(item)">修改</el-button>
                        <el-button type="text" @click="deleteAddress(item)">删除</el-button>
                    </div>
                </div>
            </div>
        </div>
        <address-add-model :visible.sync="addVisible" @on-success="onSuccess" />
        <address-edit-model :visible.sync="editVisible" :address-id="editAddressId" @on-success="onSuccess" />
    </div>
</template>

<script>
import { validateMobile } from '@/utils/validate.js'
import api from '@/api'
import request from '@/utils/request'
import { mapGetters } from 'vuex'
import addressAddModel from './components/addressAddModel'
import addressEditModel from './components/addressEditModel'

export default {
    components: {
        addressAddModel,
        addressEditModel
    },
    computed: {
        ...mapGetters(['userId'])
    },
    data() {
        return {
            addVisible: false,
            editVisible: false,
            editAddressId: '',
            list: [],
        }
    },
    created() {
        this.getAddresList()
    },
    methods: {
        editAddress(item) {
            this.editVisible = true
            this.editAddressId = item.address_id
        },
        onSuccess() {
            this.getAddresList()
        },
        getAddresList() {
            request({
                url: api.requestUserAddressList,
                data: {
                    userId: this.userId,
                },
                loading: true
            }).then(res => {
                // console.log(res)
                if (res.errorCode == 200) {
                    this.list = res.data
                } else if (res.errorCode == -10005) {
                    this.list = []
                } else {
                    this.$message.error(res.errorMsg || '网络错误')
                }
            })
        },
        deleteAddress(item) {
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                request({
					url: api.delUserAddress,
					data: {
                        addressId: item.address_id
                    }
				}).then(res => {
                    if (res.errorCode == 200) {
                        this.$message.success('删除成功')
                        this.getAddresList()

                        // 删除接单页缓存在本地的选择地址
                        const localAddressSelectStr = sessionStorage.getItem('local_address_select')
                        if (localAddressSelectStr) {
                            try {
                                let addressSelect = JSON.parse(localAddressSelectStr)
                                if (addressSelect.address_id == item.address_id) {
                                    sessionStorage.removeItem('local_address_select')
                                }
                            } catch (error) {
                                console.log(error)
                            }
                        }

                    } else {
                        this.$message.error(res.errorMsg || '网络错误')
                    }
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.address-page {
    margin: 0 auto;
    width: 1184px;
    .header-wrap {
        padding: 24px 0;
        .header-wrap-inner {
            display: flex;
            justify-content: space-between;
        }
    }
    .main-title {
        font-size: 24px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
    }
    .main-wrap {
        padding: 0 24px;
        background: #FFFFFF;
        border-radius: 2px;
    }
    .no-content {
        padding: 120px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #ccc;
        .ic-empty {
            width: 88px;
            height: 64px;
            background: url(../../assets/icons/icon_empty.png) no-repeat;
            background-size: cover;;
        }
        .text {
            margin-top: 8px;
            font-size: 14px;
        }
    }
    .address-list {
        
        .item {
            padding: 24px 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            position: relative;
            &:last-child {
                border-bottom: none;
            }
            .phone {
                margin-left: 24px;
                margin-right: 40px;
            }
            .detail {
                width: 60%;
                margin-top: 16px;
            }
            .btns {
                position: absolute;
                top: 38px;
                right: 0;
            }
        }
    }
    .add-address-wrap {
        width: 700px;
    }
}
</style>